/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.depositGiftCard

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.depositGiftCard.GiftCardDepositApi
import features.depositGiftCard.models.TransferActionResultModel
import features.depositGiftCard.serializeGiftCardDepositState



/**
 * Deposit a giftcard [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("GiftCardDepositApi")
class GiftCardDepositApiJs {

    /**
     * Deposit a giftcard
     */
    fun depositGiftCard(
        overrideHeaders: String?, 
        depositId: String
    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = GiftCardDepositApi().depositGiftCard(
            overrideHeaders = decodedOverrideHeaders,
                        depositId = depositId
        ).toJsonResult<TransferActionResultModel>()
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observeGiftCardDepositState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        GiftCardDepositApi().giftCardDepositState.serializeGiftCardDepositState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
